import React from 'react';
import PropTypes from 'prop-types';
import { withChildren } from '@builder.io/react/lite';
import useMobileDetect from '@glowforge/gf-styled/src/hooks/useMobileDetect';

import {
  Background,
  Overlay,
  Video,
  Wrapper,
} from './hero-banner.styles';
import {
  backgroundPositions,
  backgroundRepeats,
  backgroundSizes,
  heroHeights,
} from './hero-banner.config';

export const HeroBannerV2 = ({
  attributes,
  background,
  backgroundMobile,
  backgroundPosition,
  backgroundPositionMobile,
  backgroundRepeat,
  backgroundRepeatMobile,
  backgroundSize,
  backgroundSizeMobile,
  builderState,
  heroHeightDesktop,
  heroHeightMobile,
  children,
  isVideo,
  showOverlay,
  textColor,
}) => {
  // We need to detect if we're trying to do background video image to 
  // a mobile device and suppress it since we don't show it anyway (via CSS)
  const currentDevice = useMobileDetect()

  return (
    <Wrapper
      heroHeightDesktop={heroHeightDesktop}
      heroHeightMobile={heroHeightMobile}
      includeNav={builderState?.includeNav ?? true}
      textColor={textColor}
      {...attributes}>
      <Background
        background={background}
        backgroundMobile={backgroundMobile}
        backgroundPosition={backgroundPosition}
        backgroundPositionMobile={backgroundPositionMobile}
        backgroundSize={backgroundSize}
        backgroundSizeMobile={backgroundSizeMobile}
        backgroundRepeat={backgroundRepeat}
        backgroundRepeatMobile={backgroundRepeatMobile}
        isVideo={isVideo}>
        {isVideo && !currentDevice.isSSR() && currentDevice.isDesktop() ? (
          <Video
            playsInline
            autoPlay
            loop='loop'
            muted
            width='100%'
            height='100%'>
            <source src={background} />
          </Video>
        ) : null}
      </Background>
      {showOverlay ? <Overlay opacity={25} /> : null}
      {children}
    </Wrapper>
  )
};

HeroBannerV2.propTypes = {
  attributes: PropTypes.shape({}),
  background: PropTypes.string,
  backgroundMobile: PropTypes.string,
  backgroundPosition: PropTypes.oneOf(backgroundPositions),
  backgroundPositionMobile: PropTypes.oneOf(backgroundPositions),
  backgroundRepeat: PropTypes.oneOf(backgroundRepeats),
  backgroundRepeatMobile: PropTypes.oneOf(backgroundRepeats),
  backgroundSize: PropTypes.oneOf(backgroundSizes),
  backgroundSizeMobile: PropTypes.oneOf(backgroundSizes),
  builderState: PropTypes.shape({
    includeNav: PropTypes.bool,
  }),
  heroHeightDesktop: PropTypes.oneOf(heroHeights),
  heroHeightMobile: PropTypes.oneOf(heroHeights),
  children: PropTypes.node,
  isVideo: PropTypes.bool,
  showOverlay: PropTypes.bool,
  textColor: PropTypes.string,
};

HeroBannerV2.defaultProps = {
  attributes: {},
  background: null,
  backgroundMobile: null,
  backgroundPosition: backgroundPositions[0],
  backgroundPositionMobile: backgroundPositions[0],
  backgroundRepeat: backgroundRepeats[0],
  backgroundRepeatMobile: backgroundRepeats[0],
  backgroundSize: backgroundSizes[0],
  backgroundSizeMobile: backgroundSizes[0],
  builderState: { includeNav: true },
  textColor: null,
  heroHeightDesktop: heroHeights[0],
  heroHeightMobile: heroHeights[0],
  children: null,
  isVideo: false,
  showOverlay: true,
};

export const HeroBannerWithChildren = withChildren(HeroBannerV2);
export default HeroBannerWithChildren;
